require('./app/class.home');
require('./app/class.ourapproach');
require('./app/class.portfolio');
require('./app/class.ourecosystem');
